import React, { lazy, memo, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import routes from 'navigatiors/routes';
import { useSelector } from 'react-redux';
import { selectGlobal } from 'redux/global/globalSlice';
import Loading from 'components/Loading/Loading';
import { selectAuth } from 'redux/auth/authSlice';

function Content() {
  const page = process.env.REACT_APP_SITE;
  const { role } = useSelector(selectAuth);
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        {routes.map(({ key, path, component, roles, pages }) => {
          if (pages.includes(page) && roles.includes(role)) {
            return <Route key={key} path={path} element={component} />;
          }
        })}
        <Route path="*" element={<Navigate replace to="/dashboard" />} />
      </Routes>
    </Suspense>
  );
}

export default memo(Content);

Content.whyDidYouRender = true;
